import React, { memo, useCallback, useEffect, useState } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { useUser } from 'Context/User';
import { UserModel } from 'Containers/User/Models/UserModel';
import { AvatarOrInitials } from 'Components/Avatar';
import { convertPhoneNumber, formatPhoneInternationalWithCountryCode } from 'Utils/helpers';

import { NonAppCrewCard } from 'Components/People/PeopleTabs/NonAppCrewTab';

interface Props {
  crew: any;
  onClickCrewCard: (crew: any) => void;
}

const NonAppCrewCardContainer = ({ crew, onClickCrewCard }: Props) => {
  const user: UserModel = useUser();
  const [phoneNumber, setPhoneNumber] = useState('');

  const {
    id,
    firstName,
    lastName,
    fullName,
    email,
    laborRate,
    primaryPhone,
    primaryPhoneExtension,
  } = crew;

  useEffect(() => {
    if (user?.id) {
      const { companies } = user;
      if (companies.length > 0) {
        const [company] = companies;
        const { country_code: countryCode } = company;
        if (primaryPhone) {
          const phoneFormatted = convertPhoneNumber(countryCode, primaryPhone);
          setPhoneNumber(formatPhoneInternationalWithCountryCode(countryCode, phoneFormatted.toString()));
        }
      }
    }
  }, [user, primaryPhone]);

  const onClickCard = useCallback(() => {
    onClickCrewCard(crew);
  }, [crew]);

  return (
    <NonAppCrewCard
      id={id}
      avatar={<AvatarOrInitials avatar="" firstName={firstName} lastName={lastName} />}
      name={fullName}
      email={email}
      phone={phoneNumber}
      extension={primaryPhoneExtension}
      laborRate={laborRate}
      selectCardClick={onClickCard}
    />
  );
};

const NonAppCrewCardContainerMemo = memo(NonAppCrewCardContainer, areEqual);

export { NonAppCrewCardContainerMemo as NonAppCrewCard };
